<template>
  <div class="card">
    <PaymentElement
      v-if="IMMEDIATELY_SHOW_PAYMENT_ELEMENT"
      :newsletter="newsletter"
      :email-address="emailAddress"
    />

    <template v-else>
      <MagicLinkSection
        :newsletter="newsletter"
        :email-address="emailAddress"
        :purchase-url="purchaseUrl"
        :subscribe-button-text="subscribeButtonText"
      />
    </template>
  </div>
</template>

<script setup lang="ts">
import { computed, defineAsyncComponent } from "vue";

import type { Newsletter } from "@/types/newsletter";

import { createTranslator } from "../../lib/utils";
import { shouldImmediatelyShowPaymentElement } from "../lib";
import MagicLinkSection from "./MagicLinkSection.vue";

const PaymentElement = defineAsyncComponent(
  () => import("./PaymentElement.vue")
);

const props = defineProps<{
  newsletter: Newsletter;
  emailAddress: string;
}>();

const t = createTranslator(() => props.newsletter.locale);

const IMMEDIATELY_SHOW_PAYMENT_ELEMENT = shouldImmediatelyShowPaymentElement(
  props.newsletter
);

const purchaseUrl = computed(
  () => `https://buttondown.com/${props.newsletter.username}/buy`
);

const subscribeButtonText = computed(() => {
  if (props.newsletter.subscription_button_text) {
    return props.newsletter.subscription_button_text;
  }
  if (props.newsletter.paid_subscription_free_trial_duration) {
    return t("web.subscription.action.subscribe_free_trial");
  }
  return t("web.button.subscribe");
});
</script>
